/* eslint-disable import/prefer-default-export */
import paginateAction from '@utils/paginateAction';
import { preSubscribedGoal } from '../constants';
import { paginatorListSchema } from '../schemas';

const getPresubscribedBlocks = (goalUid, resetWithoutEmpty) => (next) => ({
  type: preSubscribedGoal.FETCH_PRESUBSCRIBED_BLOCKS,
  endpoint: next,
  method: 'get',
  key: goalUid,
  resetWithoutEmpty,
  schema: paginatorListSchema,
  directPaginatedEntity: true,
  entityType: 'feedrow',
  processData: (data) => {
    const newData = data;
    newData.results = newData.results.map((resultItem) => {
      if (resultItem.type === 'topics') {
        const item = {
          ...resultItem,
          data: resultItem.data.map((topic) => ({
            ...topic,
            plusCourseCount: topic.count,
            count: null
          }))
        };
        return {
          ...item,
          key: goalUid
        };
      }
      return {
        ...resultItem,
        key: goalUid
      };
    });
    return newData;
  }
});

export const fetchPresubscribedBlocks = (
  goalUid,
  limit = 4,
  offset = 0,
  nextPage,
  resetWithoutEmpty = false,
  forceReset = true
) =>
  paginateAction(
    `v2/uplus/subscription/pre_subscription_home/?goal_uid=${goalUid}&limit=${limit}&offset=${offset}&v=10`,
    getPresubscribedBlocks(goalUid, resetWithoutEmpty),
    'preSubscribedBlocks',
    goalUid,
    resetWithoutEmpty,
    forceReset
  )(nextPage);
